import { render, staticRenderFns } from "./resetPwdModal.vue?vue&type=template&id=42134623&scoped=true&"
import script from "./resetPwdModal.vue?vue&type=script&lang=js&"
export * from "./resetPwdModal.vue?vue&type=script&lang=js&"
import style0 from "./resetPwdModal.vue?vue&type=style&index=0&id=42134623&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42134623",
  null
  
)

export default component.exports